import { render, staticRenderFns } from "./Aibhbi.vue?vue&type=template&id=0161c34c&scoped=true&"
import script from "./Aibhbi.vue?vue&type=script&lang=js&"
export * from "./Aibhbi.vue?vue&type=script&lang=js&"
import style0 from "./Aibhbi.vue?vue&type=style&index=0&id=0161c34c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0161c34c",
  null
  
)

export default component.exports